/* eslint-disable prettier/prettier */
export const DashboardView = () => import(/* webpackChunkName: "core-module" */ "@/views/dashboard/index.vue");
export const IntroView = () => import( /* webpackChunkName: "core-module" */ "@/views/dashboard/intro.vue");
